import { Button, Checkbox, Form, Input, Modal, Space, Switch, Table, Typography } from 'antd';
import Header from '../../components/Header';
import InjectMessage from '../../../../utils/InjectMessage';
import { useCallback, useEffect, useState } from 'react';
import { MANAGE_ADMIN } from '../../../../redux/actions/actionTypes';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../redux/reducers';
import Icon, { IconName } from '../../components/Icon';

const Account = () => {
  const dispatch = useDispatch();
  const detailAdmin = useSelector((app: AppState) => app.manageAdmin.detailAdmin);
  const { listAdmin } = useSelector((app: AppState) => app.manageAdmin);
  const [type, setType] = useState('create');
  const [form] = Form.useForm();

  useEffect(() => {
    if (type == 'update') {
      if (detailAdmin && Object.keys(detailAdmin).length !== 0 && detailAdmin.constructor === Object) {
        form.setFieldsValue({
          // avatar: detailAdmin.avatar, 
          emailLogin: detailAdmin.emailLogin,
          name: detailAdmin.name,
          emailRegister: detailAdmin.emailRegister,
          management_student: detailAdmin.roles.some((roleItem: any) => roleItem.slug === 'management-student' && roleItem.isEnable),
          management_mentor: detailAdmin.roles.some((roleItem: any) => roleItem.slug === 'management-mentor' && roleItem.isEnable),
          management_exam: detailAdmin.roles.some((roleItem: any) => roleItem.slug === 'management-exam' && roleItem.isEnable),
          management_course: detailAdmin.roles.some((roleItem: any) => roleItem.slug === 'management-course' && roleItem.isEnable),
          isActive: detailAdmin.isActive,
          id: detailAdmin.id
        })
      }
    }
  }), [type, detailAdmin];

  const onFinish = useCallback((data: any) => {
    const { emailLogin, name, emailRegister, password, isActive, id } = data;
    if (type == 'update') {
      const editAccountData = {
        id,
        emailLogin,
        name,
        emailRegister,
        roles: Object.entries(data)
          .filter(([key]) => key.startsWith("management_"))
          .map(([key, value]) => ({
            roleType: key.replace("_", "-"),
            isEnable: value ? value : false
          })),
        isActive
      };
      Modal.confirm({
        title: 'XÁC NHẬN',
        content: 'Xác nhận sửa tài khoản ?',
        onOk: () => {
          setType('create');
          form.resetFields();
          dispatch(MANAGE_ADMIN.EDIT_ACCOUNT(editAccountData))
        }
      });
    } else {
      const createAccountData = {
        emailLogin,
        name,
        emailRegister,
        roles: Object.entries(data)
          .filter(([key]) => key.startsWith('management_'))
          .map(([key, value]) => ({
            roleType: key.replace('_', '-'),
            isEnable: value ? value : false
          })),
        password
      };
      Modal.confirm({
        title: 'Xác nhận tạo tài khoản',
        onOk: () => {
          setType('create');
          form.resetFields();
          dispatch(MANAGE_ADMIN.CREATE_ACCOUNT(createAccountData));
        }
      });
    }

  }, [type]);

  useEffect(() => {
    dispatch(MANAGE_ADMIN.GET_ACCOUNT({ offset: 0, limit: 10, token: 'xxxx' }));
  }, []);
  const { Title } = Typography;

  return <div className='h-sidebar'>

    <Header titleRight={<h3 className='text-3xl font-bold'>Danh sách</h3>}
      title={type == 'create' ? <h3 className='text-3xl font-bold'>Tạo tài khoản</h3> :
        <div className='flex flex-row'>
          {/* <Button onClick={() => setType('create')} className='bold bg-yellow' type='primary'>Quay lại</Button> */}
          <div onClick={() => {
            setType('create');
            form.resetFields();
          }}>
            <Icon classIcon='mr-1' showMask={false} width={24} height={24} name={IconName.arrowLeft} />
          </div>
          <h3 className='text-3xl font-bold'>Sửa tài khoản</h3>
        </div>
      } />
    <div className='grid gap-4 grid-cols-7'>
      <div className='col-span-3'>
        <div className='bg-white p-4 rounded-2xl'>
          <Form form={form} onFinish={onFinish} size='large' labelCol={{ sm: 8 }} labelAlign='left'>
            <Form.Item
              name='name'
              rules={[
                { required: true, validateTrigger: 'onFinish', message: 'Tên bắt buộc' }
              ]}
              label='Tên'>
              <Input />
            </Form.Item>
            <Form.Item
              name='emailRegister'
              rules={[
                { required: true, validateTrigger: 'onFinish', message: 'Email Beva bắt buộc' },
                { type: 'email', validateTrigger: 'onFinish', message: 'Email không đúng định dạng' }
              ]}
              label='Email cá nhân'>
              <Input />
            </Form.Item>
            <Form.Item
              name='emailLogin'
              rules={[
                { required: true, validateTrigger: 'onFinish', message: 'Email Beva bắt buộc' },
                {
                  type: 'email',
                  validateTrigger: 'onFinish',
                  message: 'Email không đúng định dạng'
                },
                {
                  validateTrigger: 'onFinish',
                  validator: async (rule: any, value: any) => {
                    if (value) {
                      if (!(value.endsWith("@beva.edu.vn") || value.endsWith("@beva.training"))) {
                        throw new Error('Mail Beva không hợp lệ!');
                      }
                    }

                  }
                }
              ]}
              label='Email Beva'>
              <Input />
            </Form.Item>
            {type == 'update' ? (
              <div>
                <Form.Item
                  name='isActive'
                  valuePropName="checked"
                  label={'Active'}
                >
                  <Switch
                  />
                </Form.Item>
                <Form.Item
                  name='id'
                  hidden
                >
                </Form.Item>
              </div>
            )
              : <Form.Item
                name='password'
                rules={[
                  { required: true, validateTrigger: 'onFinish', message: <InjectMessage id='auth.password.required' /> },
                  { min: 8, validateTrigger: 'onFinish', message: <InjectMessage id='auth.password.atLeast8Chars' /> }
                ]}
                label='Mật khẩu'>


                <Input.Password
                  autoComplete='new-password'
                  placeholder='Mật khẩu'
                  visibilityToggle
                />
              </Form.Item>}


            <Form.Item label='Quyền'>
              <div className='grid grid-cols-1'>
                <Form.Item
                  style={{ marginBottom: 0 }}
                  name='management_student'
                  valuePropName='checked'>
                  <Checkbox><InjectMessage id='admin.manage_student' /></Checkbox>
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: 0 }}
                  name='management_mentor'
                  valuePropName='checked'>
                  <Checkbox><InjectMessage id='admin.manage_mentor' /></Checkbox>
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: 0 }}
                  name='management_exam'
                  valuePropName='checked'>
                  <Checkbox><InjectMessage id='admin.manage_exam' /></Checkbox>
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: 0 }}
                  name='manage_course'
                  valuePropName='checked'>
                  <Checkbox><InjectMessage id='admin.manage_course' /></Checkbox>
                </Form.Item>
              </div>
            </Form.Item>
            <div className='text-end'>
              <Button htmlType='submit' type='primary'>{type == 'update' ? "Sửa tài khoản" : "Tạo tài khoản"}</Button>
            </div>
          </Form>
        </div>
      </div>
      <div className='col-span-4'>
        <div className='bg-white p-4 rounded-2xl'>
          <Table
            pagination={{
              pageSize: 8
            }}
            dataSource={listAdmin.list}
            columns={[
              { title: 'Tên', dataIndex: 'name', key: 'name' },
              { title: 'Email', dataIndex: 'emailLogin', key: 'email' },
              {
                title: 'Status', dataIndex: 'isActive', key: 'isActive',
                render: (isActive) => {
                  return <p>{isActive ? 'Active' : "Inactive"}</p>
                }
              },
              {
                title: 'Action', key: 'action',
                render: (text, record, index) => {
                  return <div>
                    <Button
                      style={{ marginRight: 8 }}
                      type="primary"
                      onClick={() => {
                        setType('update');
                        dispatch(MANAGE_ADMIN.DETAIL_ACCOUNT({ userId: record.id }))
                      }}
                    >
                      Sửa
                    </Button>
                  </div>
                },
              }
            ]}
          />
        </div>
      </div>
    </div>
  </div>;
};
export default Account;
